import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
    retrieve_warehouse_storages_list: { status: "idle" },
};

export const retrieve_warehouse_storages_list_Slice = createSlice({
    name: "retrieve_warehouse_storages_list",
    initialState,
    reducers: {
        success_retrieve_warehouse_storages_list: (state, action) => {
            state.retrieve_warehouse_storages_list = { status: app_consts.SUCCESS, data: action.payload };
        },
        fail_retrieve_warehouse_storages_list: (state, action) => {
            state.retrieve_warehouse_storages_list = { status: app_consts.FAIL, message: action.payload };
        },
        reset_retrieve_warehouse_storages_list: (state) => {
            state.retrieve_warehouse_storages_list = { status: app_consts.IDLE };
        },
        loading_retrieve_warehouse_storages_list: (state) => {
            state.retrieve_warehouse_storages_list = { status: app_consts.LOADING };
        },
    }
});

export const { success_retrieve_warehouse_storages_list, fail_retrieve_warehouse_storages_list, reset_retrieve_warehouse_storages_list, loading_retrieve_warehouse_storages_list } = retrieve_warehouse_storages_list_Slice.actions;

export default retrieve_warehouse_storages_list_Slice.reducer;